import Vue from 'vue'
import VueI18n from 'vue-i18n'
import dateTimeFormats from './dateTimeFormats'
import numberFormats from './numberFormats'

Vue.use(VueI18n)

export default (locale = 'fr') => new VueI18n({
  locale,
  fallbackLocale: 'en',
  dateTimeFormats,
  numberFormats,
  messages: {
    fr: require('./fr.json'),
    en: require('./en.json')
  }
})



// WEBPACK FOOTER //
// ./src/i18n/index.js